
// src/web/components/scrollable-dialog-panel.jsx

import React from 'react'

export default function(props) {
  return (
    <div style={{ overflow: 'scroll', marginTop: 4, height: `calc(100vh - 165px ${props.extraHeight ? '- ' + props.extraHeight + 'px' : ''})`}}>
      {props.children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/web/components/scrollable-dialog-panel.jsx